import React from "react";
import { FaClock, FaCogs, FaTruck, FaCheckCircle, FaTimesCircle, FaExchangeAlt, FaCreditCard } from "react-icons/fa";
import { elakayAutoText } from "../../pageInside/dataElakay";


// Real order-item status enum (server_elakay/elakay_models/order.js CartItemSchemaNew.status) --
// mirrors the label/icon convention already used for order rows on /c/orders
// (pageInside/CardOrders2.js's getStatusClass/getStatusIcon) but as a small, standalone
// presentational component instead of importing that whole cart-editing-capable card.
const ORDER_STATUS_META = {
  "Not processed": { get label() { return elakayAutoText("h_801cb39072a561", "Not Processed"); }, icon: FaClock, className: "ph-status--pending" },
  "Processing": { get label() { return elakayAutoText("h_e63451d3cf9004", "Processing"); }, icon: FaCogs, className: "ph-status--processing" },
  "Shipped": { get label() { return elakayAutoText("h_dec6e329089731", "Shipped"); }, icon: FaTruck, className: "ph-status--shipped" },
  "Delivered": { get label() { return elakayAutoText("h_eea956cde875f0", "Delivered"); }, icon: FaCheckCircle, className: "ph-status--delivered" },
  "Cancelled": { get label() { return elakayAutoText("h_a1bf92eff40dd4", "Cancelled"); }, icon: FaTimesCircle, className: "ph-status--cancelled" },
  "Return or replace": { get label() { return elakayAutoText("h_1850888b542cb9", "Return or Replace"); }, icon: FaExchangeAlt, className: "ph-status--return" },
};

// Translated label of an order-item status (the stored enum value never changes). Accepts the enum
// as stored ("Not processed") or in any case/spacing ("not_processed", "cancelled"); unknown values
// are returned unchanged.
const ORDER_STATUS_BY_NORMALIZED = Object.fromEntries(Object.keys(ORDER_STATUS_META).map((k) => [k.toLowerCase().replace(/[\s_-]+/g, ""), k]));
export const orderStatusLabel = (status) => {
  const key = ORDER_STATUS_META[status] ? status : ORDER_STATUS_BY_NORMALIZED[String(status || "").toLowerCase().replace(/[\s_-]+/g, "")];
  return key ? ORDER_STATUS_META[key].label : (status || "");
};

export const OrderStatusBadge = ({ status }) => {
  const meta = ORDER_STATUS_META[status];
  if (!meta) return null;
  const Icon = meta.icon;
  return (
    <span className={`ph-status-badge ${meta.className}`}>
      <Icon aria-hidden="true" />
      {meta.label}
    </span>
  );
};

// Real payment-status enum (CartItemSchemaNew.payment.status) -- only the states a buyer should
// ever see summarized as "Paid" vs "in progress"; never a fabricated status.
const PAYMENT_STATUS_META = {
  captured: { get label() { return elakayAutoText("h_dc9d4584a55464", "Paid"); }, className: "ph-payment--paid" },
  authorized: { get label() { return elakayAutoText("h_55e9510d72ffbb", "Payment Authorized"); }, className: "ph-payment--pending" },
  capturing: { get label() { return elakayAutoText("h_83723283683c7f", "Processing Payment"); }, className: "ph-payment--pending" },
  requires_action: { get label() { return elakayAutoText("h_4cd4f41475e226", "Action Required"); }, className: "ph-payment--pending" },
  canceled: { get label() { return elakayAutoText("h_d2ba3687a14e3e", "Payment Cancelled"); }, className: "ph-payment--cancelled" },
  capture_failed: { get label() { return elakayAutoText("h_d3437ac9dab0f5", "Payment Failed"); }, className: "ph-payment--cancelled" },
};

export const PaymentStatusBadge = ({ status }) => {
  const meta = PAYMENT_STATUS_META[status];
  if (!meta) return null;
  return (
    <span className={`ph-status-badge ${meta.className}`}>
      <FaCreditCard aria-hidden="true" />
      {meta.label}
    </span>
  );
};
